// Copyright (c) 2021 Patrick Amrein <amrein@ubique.ch>
//
// This software is released under the MIT License.
// https://opensource.org/licenses/MIT

import React, { createContext, useContext } from 'react';

import { SigninManager, useProvideAuth } from './AuthProvider';

export const authContext = createContext<SigninManager>({
    user: undefined,
    authorities: [],
    signin: async () => {
        Promise.resolve();
    },
    signout: () => {
        console.warn('signedout');
    },
    isSignedIn: () => false,
});

// Hook for child components to get the auth object ...
// ... and re-render when it changes.
export const useAuth = (): SigninManager => {
    return useContext(authContext);
};

export const AuthenticationProvider = ({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement => {
    const auth = useProvideAuth();
    return <authContext.Provider value={auth}>{children}</authContext.Provider>;
};
